import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import axios from 'axios';
import {PaymentElement} from '@stripe/react-stripe-js';
import "./payment.css"


const CARD_OPTIONS = {
  style: {
    base: {
      iconColor: '#c4f0ff',
      color: '#fff',
      fontWeight: '500',
      fontFamily:  "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: '16px',
      fontSmoothing: 'antialiased',
      ':-webkit-autofill': {
        color: '#fce883',
      },
      '::placeholder': {
        color: '#87BBFD',
      },
    },
    invalid: {
      iconColor: '#FFC7EE',
      color: '#FFC7EE',
    },
  },
}

export default function PaymentForm() {
  const [errorMessage, setErrorMessage] = useState(null);
  const [ processing, setProcessing ] = useState(false);
  // initialize useStripe and useEffect hook
  const stripe = useStripe();
  const elements = useElements();

  // handle submit function
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setProcessing(true);

    const {error} = await stripe.confirmPayment({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/allCv`,
      },
    });


    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      setProcessing(false);
    }
  };
  
  return (
      <div className='head'>
        <div className='payment'>
          <form onSubmit={handleSubmit}>
            <PaymentElement />
            <button disabled={processing} style={{backgroundColor: "#5843BD", width: "100%", background: "#f6a4eb", display: "flex", justifyContent: "center", height: 30, alignItems: "center"}}>
              <span>
              {processing ? <h6>Processing</h6> : <h6>Pay Now</h6>}
              </span>
            </button>
            {/* Show error message to your customers */}
            {errorMessage && <div>{errorMessage}</div>}
          </form>
        </div>
      </div>
  )
}
